/** Slack applied to badge time requirements vs player-facing descriptions. */
export const TIME_BUFFER_PERCENT = 0.1
export const TIME_BUFFER_MAX_MS = 1200

/** Returns a requirement time in ms with the standard evaluation buffer applied. */
export function bufferedTimeMs(descriptionMs: number): number {
  const bufferMs = Math.min(descriptionMs * TIME_BUFFER_PERCENT, TIME_BUFFER_MAX_MS)
  return descriptionMs + bufferMs
}
